import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class grittiVeloceIMPRESA {
  public static  offerta ():Offerte {
      return {
		Flg_Indicizzato: false,
        Id_Offerta: 208,
        Id_Foritore: 2,
        Id_comodity: 1,
        TipoContratto:2,
        NomeOfferta: "VELOCE IMPRESA",
        LinkFoto: "./assets/images/offerte-gritti/Veloce-IMPRESA.jpg",
        LinkFotoLarge: "./assets/images/offerte-gritti/Veloce-IMPRESA.jpg",
        LinkFotoMid: "./assets/images/offerte-gritti/Veloce-IMPRESA.jpg",
        LinkFotoSm: "./assets/images/offerte-gritti/Veloce-IMPRESA.jpg",
        LinkFotoCarousel: "./assets/images/offerte-gritti/Veloce-IMPRESA.jpg",
        DescrizioneCarousel: "Che Offerta super",
        DescrizioneNomeOfferta: "PREZZO COMPONENTE ENERGETICA BLOCCATO PER 12 MESI e fornitura di energia elettrica proveniente da FONTI RINNOVABILI SENZA ALCUN COSTO AGGIUNTIVO",
        PromozioneOfferta: "",
        Sezioni: [
          {
            NomeSezione: "VANTAGGI ASSICURATI",
            DescrizioneSezione: "",
            lstPunti: ["0 COSTI DI ATTIVAZIONE","12 MESI PREZZO FISSO","0 DEPOSITO CAUZIONALE","AREA RISERVATA WEB","ASSISTENZA CLIENTI",
            "TARIFFA A 3 FASCE - F1 0,08907kWh / F2 0,08846kWh / F3 0,07539kWh "
            ]
          },
      
        ],
        PrezzoEle: 0,
        PrezzoGas: 0,
       
        TitoloPlus: "VANTAGGI ASSICURATI",
        Plus:["0 COSTI DI ATTIVAZIONE","12 MESI PREZZO FISSO","0 DEPOSITO CAUZIONALE","AREA RISERVATA WEB","ASSISTENZA CLIENTI",
      ]
      ,schedaconfrontabilitaele:  
      { tabellaConfrontabilita:[ ]}

      ,schedaconfrontabilitagas:
      {
        tabellaConfrontabilita:[]
      }
      ,lstModalitaPagamento :["1","2"]
      ,scontoRid:0 
      ,TipoSoglieEle: Soglie.SoglieEle4Fasce()
      ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
      };
    }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/grittiVeloceIMPRESA.ts